import React from "react";

export default function CityDescription({ filter, city }) {
  switch (filter) {
    case "School Score":
      return (
        <>
          Discover{city}'s top neighborhoods based on schools, using official
          data from the state of California.
        </>
      );
    case "Safety Score":
      return (
        <>
          Find {city}’s safest neighborhoods, ranked by the lowest reported
          crime rates.
        </>
      );
    case "Amenities Score":
      return (
        <>
          Neighborhoods in {city} with the best amenities, from shopping and
          dining to parks and curb appeal.
        </>
      );
    case "Lowest Price":
      return (
        <>
          Uncover {city}'s most affordable neighborhoods, based on a weighted
          median price from recent sales.
        </>
      );
    case "Highest Price":
      return (
        <>
          Uncover {city}'s most affordable neighborhoods, based on a weighted
          median price from recent sales.
        </>
      );
    case "Most Undervalued":
      return (
        <>
          Identify neighborhoods in {city} that are most undervalued, where your
          dollar goes further.
        </>
      );
    case "Best Appreciation":
      return (
        <>
          Here are {city}'s neighborhoods with the most positive appreciation
          trends, based on recent sales data.
        </>
      );
    default:
      return (
        <>
          Top neighborhoods overall in {city}, based on data on schools, safety,
          amenities, and more.
        </>
      );
  }
}
